export const SUGGESTIONS_SIZE = {
    width: 356,
    height: 504,
}

export const NO_DEFINED_DESCRIPTION = 'No Defined Description'
export const NO_DEFINED_VALUE = 'No Defined Value'
export const SUGGESTIONS_INFO_TITLE = 'What is scoped variable?'
